import { createSlice } from "@reduxjs/toolkit";
import { IPayerAddressItem } from "../Infrastructure/Interfaces";

const ItemInitialState: IPayerAddressItem = {
    payerAddressId: 0,
    payerMasterId: 0,
    payerName: '',
    payerId: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    phoneNo: '',
    faxNo: '',
    isActive: true,
    createdBy: '',
    createdOn: '',
    modifiedBy: '',
    modifiedOn: '',
}

const PayerAddressItemSlice = createSlice({
    name:'PayerAddressItem',
    initialState:{value:ItemInitialState},
    reducers:{
        setPayerAddressItem:(state,action)=>{
            state.value = action.payload
        }
    }
  });

  export const {setPayerAddressItem} = PayerAddressItemSlice.actions;
  
  export const PayerAddressItemReducer = PayerAddressItemSlice.reducer;